import { type FC, type PropsWithChildren, type ReactElement } from "react";

import { COLUMN_SELECTION_BUTTON_PLACEHOLDER_ID } from "@/ui-modules/core/grid/settings.ts";

const ColumnSelectionButton: FC<PropsWithChildren<{ portalContext?: string }>> = (props): ReactElement => {
  const portalContext: string = props.portalContext || "";
  return (
    <span
      key={COLUMN_SELECTION_BUTTON_PLACEHOLDER_ID + portalContext}
      id={COLUMN_SELECTION_BUTTON_PLACEHOLDER_ID + portalContext}
    />
  );
};

export default ColumnSelectionButton;
